module.exports = __webpack_public_path__ + "img/indus-pic-14.6d874345.png";